"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.unByKey = unByKey;

var _Target = _interopRequireDefault(require("./events/Target.js"));

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _events = require("./events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Observable
 */


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */

/***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */

/**
 * @typedef {'change'|'error'} EventTypes
 */

/***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */
var Observable =
/** @class */
function (_super) {
  __extends(Observable, _super);

  function Observable() {
    var _this = _super.call(this) || this;

    _this.on =
    /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    _this.onInternal;
    _this.once =
    /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    _this.onceInternal;
    _this.un =
    /** @type {ObservableOnSignature<void>} */
    _this.unInternal;
    /**
     * @private
     * @type {number}
     */

    _this.revision_ = 0;
    return _this;
  }
  /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */


  Observable.prototype.changed = function () {
    ++this.revision_;
    this.dispatchEvent(_EventType["default"].CHANGE);
  };
  /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */


  Observable.prototype.getRevision = function () {
    return this.revision_;
  };
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */


  Observable.prototype.onInternal = function (type, listener) {
    if (Array.isArray(type)) {
      var len = type.length;
      var keys = new Array(len);

      for (var i = 0; i < len; ++i) {
        keys[i] = (0, _events.listen)(this, type[i], listener);
      }

      return keys;
    } else {
      return (0, _events.listen)(this,
      /** @type {string} */
      type, listener);
    }
  };
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */


  Observable.prototype.onceInternal = function (type, listener) {
    var key;

    if (Array.isArray(type)) {
      var len = type.length;
      key = new Array(len);

      for (var i = 0; i < len; ++i) {
        key[i] = (0, _events.listenOnce)(this, type[i], listener);
      }
    } else {
      key = (0, _events.listenOnce)(this,
      /** @type {string} */
      type, listener);
    }
    /** @type {Object} */


    listener.ol_key = key;
    return key;
  };
  /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */


  Observable.prototype.unInternal = function (type, listener) {
    var key =
    /** @type {Object} */
    listener.ol_key;

    if (key) {
      unByKey(key);
    } else if (Array.isArray(type)) {
      for (var i = 0, ii = type.length; i < ii; ++i) {
        this.removeEventListener(type[i], listener);
      }
    } else {
      this.removeEventListener(type, listener);
    }
  };

  return Observable;
}(_Target["default"]);
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */


Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */

Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */

Observable.prototype.un;
/**
 * Removes an event listener using the key returned by `on()` or `once()`.
 * @param {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} key The key returned by `on()`
 *     or `once()` (or an array of keys).
 * @api
 */

function unByKey(key) {
  if (Array.isArray(key)) {
    for (var i = 0, ii = key.length; i < ii; ++i) {
      (0, _events.unlistenByKey)(key[i]);
    }
  } else {
    (0, _events.unlistenByKey)(
    /** @type {import("./events.js").EventsKey} */
    key);
  }
}

var _default = Observable;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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